import { styled, Typography } from "@mui/material";
import { useIntl } from "react-intl";
import { Participant } from "twilio-video";
import { getInvertColor } from "utils/themeUtils";
import { convertHexToRGBA } from "../../utils/commonUtils";

const Container = styled("div")(({ theme }) => ({
	position: "relative",
	height: "100%",
	width: "100%",
	backgroundColor: "#000",
	borderRadius: 5,
	overflow: "hidden",
}));

const InnerContainer = styled("div")({
	position: "absolute",
	width: "100%",
	height: "100%",
});

const ParticipantName = styled(Typography)(({ theme }) => ({
	position: "absolute",
	bottom: 0,
	left: 0,
	background: convertHexToRGBA(theme.palette.primary.main, 0.6),
	borderRadius: "0 5px",
	zIndex: 10,
	color: getInvertColor(theme.palette.primary.main),
	padding: "0 8px",
	fontWeight: "normal",
	fontSize: 13,
	textAlign: "left",
}));

interface Props {
	participant: Participant;
	isLocalParticipant: boolean;
}
export const ParticipantInfo: React.FC<Props> = ({ participant, isLocalParticipant, children }) => {
	const intl = useIntl();
	const [, participantName] = participant.identity.split("@#");
	const localParticipantText = intl.formatMessage({ id: "CALL.participant_info.name.you" });
	return (
		<Container>
			<InnerContainer>
				<ParticipantName>
					{isLocalParticipant ? localParticipantText : participantName.split("-")[0]}
				</ParticipantName>
			</InnerContainer>
			<InnerContainer>{children}</InnerContainer>
		</Container>
	);
};
